import { css } from '@microsoft/fast-element';
export const foundationFilterBarStyles = (context, definition) => css `
  .filter-bar {
    background-color: #2c2f33;
    padding: calc(var(--design-unit) * 2px);
    transition: all 0.5s ease-out;
  }

  .filter-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: minmax(64px, auto);
    gap: calc(var(--design-unit) * 1px);
    align-items: end;
    justify-items: stretch;
  }

  .toggle {
    display: flex;
    justify-content: center;
    min-height: 20px;
    cursor: pointer;
    border-radius: calc(var(--control-corner-radius) * 1px) calc(var(--control-corner-radius) * 1px)
      0 0;
    border-top: 2px solid;
    color: #f44378;
  }

  .collapsed {
    max-height: 0;
    padding: 0;
    overflow: hidden;
  }

  .toggle-collapsed {
    color: #48ed9c;
  }
`;
